export const animationSources = {
    crystalBall: require("./crystalBall.json"),
    envelope: require("./envelope.json"),
    hat: require("./hat.json"),
    heart: require("./heart.json"),
    "brand-loading": require("./brand-loading.json"),
    "brand-loading-purple-bg": require("./brand-loading-purple-bg.json"),
    thinking: require("./thinking.json"),
};
